import React from "react";
import VoucherHistory from "@components/VoucherManager/VoucherPurchases/VoucherHistory";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const VoucherHistoryPage = () => {

    return (
        <VersionedLayout>
            <VoucherHistory />
        </VersionedLayout>
    );
};

export default VoucherHistoryPage;
